import React from 'react';
import PropTypes from 'prop-types';
import { Link, Type } from '@nerdwallet/currency';
import Icon from '@nerdwallet/react-icon';
import lazy, { Hydrate } from '../../../lazy/lazy-universal';

import style from './fthb-program.module.less';

const FTHBProgramCard = lazy(
  () =>
    import(
      /* webpackChunkName: 'lazy-fthb-program-card' */ '../../../../containers/fthb-program-card'
    ),
  { hydrate: Hydrate.WHEN_VISIBLE }
);

const FTHBProgram = ({
  fthbBody,
  fthbStateProgramProductId,
  fthbStateProgramUrl,
  fthbTitle,
}) => {
  if (!fthbStateProgramProductId) {
    return null;
  }

  return (
    <div className={style.container}>
      <Type size={3} component="h3" bold className={style.heading}>
        {fthbTitle}
      </Type>
      <Type className={style.copy}>{fthbBody}</Type>
      <FTHBProgramCard />
      <Type className={style.link}>
        <Link href={fthbStateProgramUrl} target="_blank">
          See full article <Icon icon="navigateright" />
        </Link>
      </Type>
    </div>
  );
};

FTHBProgram.propTypes = {
  fthbBody: PropTypes.string.isRequired,
  fthbStateProgramProductId: PropTypes.string.isRequired,
  fthbStateProgramUrl: PropTypes.string.isRequired,
  fthbTitle: PropTypes.string.isRequired,
};

export default FTHBProgram;
